/**
 * Prefixo de URL /expedition/resumapas/* → API expedition_context=resumaps.
 * Rotas /expedition/* (sem resumapas) → expedition_context=expedition.
 * API: expedition_context=none|expedition|resumaps.
 */
export const EXPEDITION_LIST_CONTEXT = {
    NONE: 'none',
    EXPEDITION: 'expedition',
    RESUMAPS: 'resumaps',
};

const RESUMAPAS_PATH_PREFIX = '/expedition/resumapas';

/**
 * Base para Links (ex.: /expedition ou /expedition/resumapas).
 */
export function getExpeditionBasePathFromPathname(pathname) {
    const p = pathname || '';
    if (p === RESUMAPAS_PATH_PREFIX || p.startsWith(RESUMAPAS_PATH_PREFIX + '/')) {
        return RESUMAPAS_PATH_PREFIX;
    }
    return '/expedition';
}

/**
 * Valor enviado em expedition_context nas chamadas à API.
 */
export function getApiExpeditionContextFromPathname(pathname) {
    const p = pathname || '';
    if (p === RESUMAPAS_PATH_PREFIX || p.startsWith(RESUMAPAS_PATH_PREFIX + '/')) {
        return EXPEDITION_LIST_CONTEXT.RESUMAPS;
    }
    if (p.startsWith('/expedition/')) {
        return EXPEDITION_LIST_CONTEXT.EXPEDITION;
    }
    return EXPEDITION_LIST_CONTEXT.NONE;
}

/**
 * Texto do contexto no cabeçalho (rotas /expedition/... vs /expedition/resumapas/...).
 */
export function expeditionFlowsTitle(pathname) {
    return getApiExpeditionContextFromPathname(pathname) === EXPEDITION_LIST_CONTEXT.RESUMAPS
        ? 'Resumapas'
        : 'Expedição';
}

/**
 * Config axios { params: { expedition_context } } a partir da rota atual.
 */
export function expeditionContextAxiosParams(pathname) {
    return {
        params: {expedition_context: getApiExpeditionContextFromPathname(pathname)},
    };
}
